import React, { useEffect, useRef, useState } from 'react';

type CountUpProps = {
  value: number;
  durationMs?: number;
  formatter?: (v: number) => string;
};

const defaultFormatter = (v: number) => Math.round(v).toLocaleString();

export function CountUp({ value, durationMs = 700, formatter = defaultFormatter }: CountUpProps) {
  const [display, setDisplay] = useState<number>(value);
  const startRef = useRef<number>(value);
  const rafRef = useRef<number | null>(null);

  useEffect(() => {
    const startValue = startRef.current;
    const delta = value - startValue;
    const startTime = performance.now();

    const step = (ts: number) => {
      const progress = Math.min(1, (ts - startTime) / durationMs);
      const next = startValue + delta * progress;
      setDisplay(next);
      if (progress < 1) {
        rafRef.current = requestAnimationFrame(step);
      } else {
        startRef.current = value;
      }
    };

    rafRef.current = requestAnimationFrame(step);

    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [value, durationMs]);

  return <>{formatter(display)}</>;
}
